export default __webpack_public_path__ + "static/media/schedule_illustration.aced2323.svg";